import { useCallback, useEffect, useState } from 'react';
import { NetworkResult, PagedResultState } from '../../../common/CommonResult';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { API } from '../../../api';
import {
  Button,
  Card,
  Col,
  Form,
  message,
  Modal,
  Row,
  Select,
  Space,
  Switch,
  Table,
  TablePaginationConfig,
  Tag,
} from 'antd';
import BranchSelect from '../../../lib/BranchSelect';
import { notifyError, notifySuccess } from '../../../store/utils';

export const AddressNew = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchState, changeSearchState] = useState<any>({});
  const [selectedAddress, setSelectedAddress] = useState<any>({ visible: false, record: null });
  const [state, setState] = useState<NetworkResult<any>>({
    loading: true,
    result: {},
  });
  const changeSearch = useCallback(
    (val: any) => {
      const res = { ...queryString.parse(location.search), ...val };
      navigate(`?${queryString.stringify(res)}`);
    },
    [navigate, location]
  );
  const columns = [
    {
      title: 'Зип код',
      dataIndex: 'zipcode',
      key: 'zipcode',
    },
    {
      title: 'Нэр',
      render: (record: any) => (
        <div>
          {record?.addressString}, {record.description}
        </div>
      ),
      key: 'addressString',
    },
    {
      title: 'Харьяалах салбар',
      dataIndex: 'courierBranchAddresses',
      key: 'courierBranchAddresses',
      render: (record: any[]) => (
        <div>
          {record?.map((item) => {
            return (
              <Tag>
                {item?.courierBranch?.name}-{item?.deliveryType?.text}
              </Tag>
            );
          })}
        </div>
      ),
    },
    {
      title: 'Харьяалах бүс',
      dataIndex: 'areas',
      key: 'areas',
      render: (record: any[]) => (
        <div>
          {record?.map((item) => {
            return <Tag>{item?.name}</Tag>;
          })}
        </div>
      ),
    },
    {
      title: '',
      render: (record: any) => (
        <Button type="primary" onClick={() => setSelectedAddress({ visible: true, record })}>
          Харьяалах
        </Button>
      ),
    },
  ];
  useEffect(() => {
    if (location.search) {
      changeSearchState(queryString.parse(location.search));
      fetchContent(location.search);
    } else {
      navigate(`?page=1`);
    }
  }, [location.search, navigate]);
  const fetchContent = async (search: string) => {
    setState({
      loading: true,
      result: {},
    });
    const response = await API.get({})(`/common/address/no-branch${search}`);
    setState({
      loading: false,
      result: response.result,
    });
  };
  const submitCreate = useCallback(
    async (data: any) => {
      const payload = {
        deliveryType: data.deliveryType,
        districtNo: selectedAddress.record.district.no,
        provinceNo: selectedAddress.record.province.no,
        streetNo: selectedAddress.record.no,
      };

      try {
        if (data.deliveryType === 'BOTH') {
          await sendRequest(data.branch, { ...payload, deliveryType: 'HOMEDELIVERY' });
          await sendRequest(data.branch, { ...payload, deliveryType: 'PICKUP' });
        } else {
          await sendRequest(data.branch, payload);
        }
        notifySuccess('Амжилттай хадгаллаа');
        fetchContent(location.search);
      } catch (error: any) {
        notifyError(error.message);
      } finally {
        setSelectedAddress({ visible: false, record: null });
      }
    },
    [selectedAddress]
  );
  const handleTableChange = (pagination: TablePaginationConfig) => {
    const params = queryString.parse(location.search);
    const search = {
      ...params,
      page: pagination.current || 1,
      size: pagination.pageSize,
    };
    navigate(`/settings/address?${queryString.stringify(search)}`);
  };
  const sendRequest = async (branch: any, data: any) => {
    await API.post({ apiVersion: 'api' })(`/branch/address/create/${branch}`, data);
  };
  return (
    <Card title="Хаягийн жагсаалт">
      <Space wrap style={{ marginBottom: 15 }}>
        <Select
          allowClear
          style={{ width: 150 }}
          value={searchState.provinceNo}
          onChange={(e) => changeSearch({ provinceNo: e })}
        >
          {state.result?.data?.provinces?.map((item: any) => {
            return (
              <Select.Option key={item.no} value={item.no + ''}>
                {item.name}
              </Select.Option>
            );
          })}
        </Select>
        <Select
          allowClear
          style={{ width: 150 }}
          value={searchState.districtNo}
          onChange={(e) => changeSearch({ districtNo: e })}
        >
          {state.result?.data?.districts?.map((item: any) => {
            return (
              <Select.Option key={item.no} value={item.no + ''}>
                {item.name}
              </Select.Option>
            );
          })}
        </Select>
        <Select
          allowClear
          style={{ width: 150 }}
          value={searchState.deliveryType}
          onChange={(e) => changeSearch({ deliveryType: e })}
        >
          <Select.Option key="HOMEDELIVERY" value="HOMEDELIVERY">
            Гараас гарт
          </Select.Option>
          <Select.Option key="PICKUP" value="PICKUP">
            Салбараас авах
          </Select.Option>
        </Select>
        <Form.Item label="Бүсэд бүртгэлгүй">
          <Switch onChange={(e) => changeSearch({ noArea: true })} />
        </Form.Item>
      </Space>

      <Table
        size="small"
        loading={state.loading}
        onChange={handleTableChange}
        dataSource={state.result?.data?.streets || []}
        rowKey={'no'}
        pagination={{
          current: state?.result?.page || 1,
          size: 'small',
          pageSize: state?.result?.size || 10,
          total: state?.result?.total,
        }}
        // onChange={handleTableChange}
        columns={columns}
      />
      <BranchSelectModal
        visible={selectedAddress.visible}
        record={selectedAddress.record}
        onOk={submitCreate}
        onClose={() => setSelectedAddress({ visible: false, record: null })}
      />
    </Card>
  );
};

interface Props {
  visible: boolean;
  onOk: (value: { branch: string; deliveryType: string }) => void;
  record?: any;
  onClose: () => void;
}
const BranchSelectModal = ({ visible, onOk, onClose, record }: Props) => {
  const [branch, changeBranch] = useState<any>('');
  const [deliveryType, changeDeliveryType] = useState<any>(null);
  useEffect(() => {
    if (visible) {
      changeBranch(null);
      changeDeliveryType(null);
    }
  }, [visible]);
  const handleOk = useCallback(() => {
    if (branch && deliveryType) {
      onOk({ branch, deliveryType });
    } else {
      notifyError('Харьяалах салбар, харьяалах төрөл сонгоно уу');
    }
  }, [branch, deliveryType]);
  return (
    <Modal
      title={`Харьяалах салбар ${record?.addressString}`}
      open={visible}
      onCancel={onClose}
      onOk={handleOk}
    >
      <Row gutter={15}>
        <Col span={24}>
          <BranchSelect
            showSearch
            allowClear
            value={branch}
            onChange={(value?: string) => changeBranch(value)}
          />
        </Col>
        <Col span={24}>
          <Select
            style={{ width: '100%' }}
            value={deliveryType}
            onChange={(value?: string) => changeDeliveryType(value)}
          >
            <Select.Option value="HOMEDELIVERY">Гараас гарт</Select.Option>
            <Select.Option value="PICKUP">Салбараас авах</Select.Option>
            <Select.Option value="BOTH">Бүгд</Select.Option>
          </Select>
        </Col>
      </Row>
    </Modal>
  );
};
